export class Crumb {
    constructor(
        public name: string,
        public id: string,
        public parent: string,
        public site?: string) {
    }
}
  